import Reveal from "../Reveal";

export const ArticleBody = ({ entry, tagLabel }) => (
  <div
    className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 py-12 md:py-20 grid lg:grid-cols-12 gap-10"
    data-testid="article-body"
  >
    <div className="lg:col-span-3 hidden lg:block">
      <div className="sticky top-32 overline">{tagLabel}</div>
    </div>
    <article className="lg:col-span-7">
      <Reveal>
        <p className="font-editorial text-xl sm:text-2xl md:text-[28px] leading-[1.4] text-ink-700">
          {entry.intro}
        </p>
      </Reveal>
      <div className="mt-10 md:mt-14 space-y-10 md:space-y-14">
        {entry.sections.map((s, i) => (
          <Reveal key={s.h} delay={i * 60}>
            <div className="overline mb-3">
              {String(i + 1).padStart(2, "0")}
            </div>
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl tracking-tightest leading-[1.08]">
              {s.h}
            </h2>
            <p className="mt-4 text-[15px] md:text-[16px] text-ink-500 leading-relaxed">
              {s.p}
            </p>
          </Reveal>
        ))}
      </div>
    </article>
  </div>
);
